import React, { useContext } from 'react';
import { useRouteMatch, Switch, Route } from 'react-router-dom';
import { Redirect } from 'react-router';
// import { PrivateRoute } from './PrivateRoute';
import { SpanishRoute } from './SpanishRoute';
import { EnglishRoute } from './EnglishRoute';
import { UserContext } from '../context';
import { EventosAdopcion } from '../pages/Eventos/Adopcion/EventosAdopcion';
import DetalleEventoAdopcion from '../pages/Eventos/Adopcion/DetalleEventoAdopcion';
import { EventosAdopciones } from '../pages/Eventos/Adopcion/EventosAdopciones';
import { AdminRoute } from './AdminRoute';

export const EventosRouter = () => {

    const { url } = useRouteMatch();
    const { languaje } = useContext(UserContext);

    return (
        <Switch>
            <Route exact path={`${url}`}>
                <Redirect to={`${url}/${languaje === 'ES' ? 'adopcion' : 'adoption'}`} />
            </Route>

            <SpanishRoute exact path={`/eventos/adopcion`} component={EventosAdopciones} />
            <EnglishRoute exact path={`/events/adoption`} component={EventosAdopciones} />

            {/* <PrivateRoute exact path={`${url}/adopcion/registro`} component={EventosAdopcion} /> */}
            <AdminRoute exact path={`${url}/adopcion/registro`} component={EventosAdopcion} />

            <SpanishRoute exact path={`/eventos/adopcion/:id`} component={DetalleEventoAdopcion} />
            <EnglishRoute exact path={`/events/adoption/:id`} component={DetalleEventoAdopcion} />



        </Switch>
    )
}
